/* eslint-disable */
export default {
  allCalls: '所有通話',
  Unknown: '未知',
  Multiple: '多個',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
